
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/international",
      function () {
        return require("private-next-pages/international/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/international"])
      });
    }
  